import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchCityData, selectCity, clearCityList } from "../../redux/actions/citiesAction";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";

const UpdateInstituteProfile = () => {
	const navigate = useNavigate();
	const sessionId = localStorage.getItem("sessionId");
	const userUID = localStorage.getItem("userUID");
	const userType = localStorage.getItem("userType");

	const [displays, setDisplays] = useState(false);
	// ...............................PROFILE Start.......................................
	const [instituteEmail, setInstituteEmail] = useState("");
	const [instituteContact, setInstituteContact] = useState("");
	const [cityValue, setCitValue] = useState("");
	const [website, setWebiste] = useState("");
	const [tagline, setTagline] = useState("");
	const [startDate, setStartDate] = useState("");
	const [profileImage, setProfileImage] = useState(null);
	const [profileImageview, setProfileImageview] = useState("");
	const [error, setError] = useState(null);
	const [about, setAbout] = useState("");
	const [description, setDescription] = useState("");
	const [address, setAddress] = useState("");

	const [toastMessage, setToastMessage] = useState("");
	const [showToast, setShowToast] = useState(false);
	const [showWarningToast, setShowWarningToast] = useState(false);
	const [showErrorToast, setShowErrorToast] = useState(false);
	const [warningToastMessage, setWarningToastMessage] = useState("");
	const [errorToastMessage, setErrorToastMessage] = useState("");
	const [genderModal, setGenderModal] = useState(true);

	// ...............................City DDL.......................................
	const dispatch = useDispatch();
	const [cityId, setcityId] = useState("");
	const { cityList, selectedcityId } = useSelector((state) => state.cities);
	useEffect(() => {
		dispatch(fetchCityData());
		return () => {
			dispatch(clearCityList()); // Clear cityList when component unmounts
		};
	}, [dispatch]);
	const handleCityInputChange = (inputValue) => {
		dispatch(fetchCityData(inputValue));
	};

	const handleCitySelect = (selectedOption) => {
		if (selectedOption) {
			setcityId(selectedOption.value);
			// dispatch(selectCity(selectedOption.value));
		} else {
			setcityId(null);
		}
	};
	// console.log("selectedcityId", selectedcityId);

	// ...............................City DDL.......................................

	const handleProfileImageChange = (event) => {
		const selectedFile = event.target.files[0];
		const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg'];

		if (selectedFile) {
			// Validate file type
			if (!validImageTypes.includes(selectedFile.type)) {
				setError('Only JPEG and PNG images are allowed.');
				setProfileImage(null);
				setProfileImageview(null);
				return;
			}

			// Validate file size (limit to 2MB)
			const maxSizeInMB = 10;
			if (selectedFile.size > maxSizeInMB * 1024 * 1024) {
				setError(`File size should not exceed ${maxSizeInMB}MB.`);
				setProfileImage(null);
				setProfileImageview(null);
				return;
			}

			// If valid, update the state
			setProfileImage(selectedFile);
			setProfileImageview(URL.createObjectURL(selectedFile));
			setError(null);
		}
	};

	const [formChanged, setFormChanged] = useState(false); // Track if form is modified
	const [isSubmitting, setIsSubmitting] = useState(false);
	// Handle changes and mark form as modified
	const handleFieldChange = (setter, value) => {
		setter(value);
		setFormChanged(true); // Enable Submit button
	};


	const InstituteUpdate = async (e) => {
		e.preventDefault();
		try {
			setDisplays(true);
			setIsSubmitting(true); // Disable the button during submission
			if (!instituteContact || instituteContact.length < 10 || instituteContact.length > 12) {
				toast.error("Contact number must be between 10 and 12 digits!");
				setDisplays(false);
				return;
			}

			const urlPattern = /^(https?:\/\/|www\.)[\w\d.-]+\.[a-zA-Z]{2,}(:[0-9]+)?(\/.*)?$/;
			if (website && !urlPattern.test(website)) {
				toast.error("Please enter a valid Test Link!");
				return;
			}

			if (
				instituteContact &&
				instituteEmail &&
				cityId &&
				// website &&
				// about &&
				// tagline &&
				// description &&
				// address &&
				startDate &&
				profileImage !== ""
			) {
				const formData = new FormData();
				formData.append("Email", instituteEmail);
				formData.append("ContactNo", instituteContact);
				formData.append("CityId", cityId);
				formData.append("Website", website || "");
				formData.append("About", about || "");
				formData.append("Tagline", tagline || "");
				// formData.append("AddressId", address);
				formData.append("Description", description || "");
				formData.append("StartedDate", startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD"));
				// formData.append("LogoImage", profileImage);
				if (profileImage) {
					formData.append("LogoImage", profileImage);
				}
				formData.append("SessionId", sessionId);

				const res = await axios.post("/Account/UpdateInstituteProfile", formData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
						},
					}
				);
				// navigate(`/Resume/Institution?userUID=${userUID}`);
				// navigate(`/${userType}/${userUID}`);

				setToastMessage(res.data.message);
				toast.success(res.data.message);
				window.location.reload();
				setShowToast(true);

				setDisplays(false);
			} else {
				toast.error("please enter required fields!");
				setIsSubmitting(false); // Re-enable the button if validation fails
				// { position: "top-center" }
			}
		} catch (error) {
			if (error.response && error.response.status === 404) {
				setWarningToastMessage(error.response.data.message);
				setShowWarningToast(true);
				toast.warning(error.response.data.message);
			} else {
				setErrorToastMessage(
					error.response?.data?.message || "An error occurred"
				);
				setShowErrorToast(true);
				toast.error(error.response?.data?.message || "An error occurred");
			}

			if (error.response && error.response.status === 404) {
				setWarningToastMessage(error.response.data.message);
				setShowWarningToast(true);
				toast.warning(error.response.data.message);
			} else {
				setErrorToastMessage(error.response.data.message);
				setShowErrorToast(true);
				// toast.error(error.response.data.message)
			}
		} finally {
			setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
		}
	};

	// ...............................PROFILE End.......................................

	// ...............................Get PROFILE Start.......................................
	const [profileData, setProfileData] = useState("");
	const GetProfile = async () => {
		try {
			const res = await axios.get(`/Institute/GetProfile?UID=${userUID}`);
			setProfileData(res.data.responseData);
			console.log("=====>", res.data.responseData);
			const userData = res.data.responseData;
			localStorage.setItem("name", userData.name);
			localStorage.setItem("startedDate", userData.startedDate);
			localStorage.setItem("compType", userData.compType);
			localStorage.setItem("cityName", userData.cityName);
			localStorage.setItem("email", userData.email);
			localStorage.setItem("profilPic", userData.logoImage);
		} catch (error) {
			console.log("error", error);
		}
	};
	useEffect(() => {
		GetProfile();
	}, []);

	useEffect(() => {
		if (profileData) {
			console.log("profileData", profileData);

			setInstituteEmail(profileData?.email);
			setInstituteContact(profileData?.contactNo);
			setWebiste(profileData?.website);
			setTagline(profileData?.tagline);
			setStartDate(profileData?.startedDate);
			setProfileImageview(profileData?.logoImage);
			setAbout(profileData?.about);
			setDescription(profileData?.description);
			setcityId(profileData?.cityId);
			dispatch(fetchCityData(profileData?.cityName));
			setAddress("");
			if (profileData?.logoImage) {
				fetch(profileData.logoImage)
					.then(response => response.blob())
					.then(blob => {
						const file = new File([blob], profileData.logoImage.split('/').pop(), { type: blob.type });
						setProfileImage(file);
					})
					.catch(error => console.error("Error fetching image:", error));
			}

		}
	}, [profileData]);

	// ...............................Get PROFILE End.......................................
	return (
		<>
			<h5 className="f-600 mb-4">Profile Setting</h5>
			<div className="profile-setting-form">
				<div className="form-row">
					<div className="form-group text-transform-email email-label-category">
						<label htmlFor="instituteEmail">Institute email</label>
						<input
							type="text"
							id="instituteEmail"
							className="form-control Dark-Input-from-group"
							placeholder="Email"
							required
							// onChange={(e) => setInstituteEmail(e.target.value)}
							onChange={(e) => handleFieldChange(setInstituteEmail, e.target.value)}
							value={instituteEmail}
							invalid={displays && instituteEmail === ""}
							disabled
						/>
						{displays && !instituteEmail ? (
							<span className="error_msg_lbl text-red">
								Enter email{" "}
							</span>
						) : null}
					</div>

					<div className="form-group">
						<label htmlFor="contact">Contact no <span className="text-red">*</span></label>
						<input
							type="number"
							id="contact"
							maxLength={12}
							className="form-control Dark-Input-from-group"
							placeholder="Contact No"
							required
							onChange={(e) => handleFieldChange(setInstituteContact, e.target.value)}
							value={instituteContact}
							invalid={displays && instituteContact === ""}
						/>
						{displays && !instituteContact ? (
							<span className="error_msg_lbl text-red">Enter no </span>
						) : null}
					</div>
				</div>
				<div className="form-row">
					{/* <div className="form-group">
						<label htmlFor="city">City</label>
						<ReactSelect
							options={cityList}
							onChange={(option) => handleFieldChange(setcityId,  option ? option.value : "")}
							value={
								cityList.find((option) => option.value === cityId) ||
								null
							}
							onInputChange={handleCityInputChange}
							placeholder="Search & Select City"
							styles={customStyles}
							classNamePrefix="react-select"
							className="form-control"
							isClearable
						/>
						{displays && !cityId ? (
							<span className="error_msg_lbl text-red">Enter City </span>
						) : null}
					</div> */}
					<div className="form-group">
						<label htmlFor="city">City <span className="text-red">*</span></label>
						<ReactSelect
							options={cityList}
							onChange={(option) => handleFieldChange(setcityId, option ? option.value : "")} // Track changes
							value={
								cityList.find((option) => option.value === cityId) ||
								null
							}
							onInputChange={handleCityInputChange}
							placeholder="Search & Select City"
							styles={customStyles}
							classNamePrefix="react-select"
							className="form-control reactselect-city-input"
							isClearable
						/>

						{displays && !cityId ? (
							<span className="error_msg_lbl text-red">Search & select city </span>
						) : null}
					</div>


					<div className="form-group text-transform-email">
						<label htmlFor="website">Website </label>
						<input
							type="url"
							id="website"
							className="form-control Dark-Input-from-group"
							placeholder="Website"
							required
							onChange={(e) => setWebiste(e.target.value)}
							// onChange={(e) => handleFieldChange(setWebiste, e.target.value)}
							value={website}
							invalid={displays && website === ""}

						/>
						{/* {displays && !website ? (
							<span className="error_msg_lbl text-red">Enter Website </span>
						) : null} */}
					</div>
				</div>
				<div className="form-row">
					<div className="form-group">
						<label htmlFor="ProfileImg">Logo image </label>
						<input
							type="file"
							id="ProfileImg"
							className="form-control Dark-Input-from-group"
							required
							accept="image/jpeg, image/png, image/jpg"
							// onChange={(e) => {
							// 	handleFieldChange(setProfileImage, e.target.files[0]);
							// 	setProfileImageview(URL.createObjectURL(e.target.files[0]));
							// }}
							onChange={(e) => {
								const selectedFile = e.target.files[0];
								if (!selectedFile) return;

								handleFieldChange(setProfileImage, selectedFile);

								// ✅ Convert file to Object URL for immediate preview
								const imageURL = URL.createObjectURL(selectedFile);
								setProfileImageview(imageURL);

								// ✅ Convert file to Base64 and save it in localStorage
								const reader = new FileReader();
								reader.onloadend = () => {
									const base64Image = reader.result;
									localStorage.setItem("profilPic", base64Image);

								};

								reader.readAsDataURL(selectedFile);
							}}
							style={{ height: '56px', paddingTop: '15px' }}
						/>

						{error && <span className="error_msg_lbl text-red">{error}</span>}
						{profileImageview && (
							<div className="inst-profile-image" style={{ width: '75px', height: '75px' }}>
								<img
									src={profileImageview}
									alt="Profile Preview"
									// width={200}
									// height={200}
									className="mt-2 rounded-circle"
								// style={{ borderRadius: '50%' }}
								/>
							</div>

						)}
					</div>

					<div className="form-group">
						<label htmlFor="IncorpDate">Start date <span className="text-red">*</span></label>
						<Flatpickr
							type="number"
							id="dob"
							className="form-control Dark-Input-from-group"
							required
							onChange={(date) => handleFieldChange(setStartDate, (date[0]))} // Track changes
							value={startDate}
							invalid={displays && startDate === ""}
							options={{
								maxDate: new Date()
							}}
						/>
						{displays && !startDate ? (
							<span className="error_msg_lbl text-red">Enter date </span>
						) : null}
					</div>
				</div>

				<div className="form-row">


				</div>

				<div className="form-group">

				</div>



				<div className="form-group mt-3">
					<label htmlFor="tagline">Tagline</label>
					<input
						type="text"
						id="tagline"
						className="form-control Dark-Input-from-group"
						placeholder="Tagline"
						required
						onChange={(e) => handleFieldChange(setTagline, e.target.value)}
						value={tagline}
						invalid={displays && tagline === ""}
					/>
					{/* {displays && !tagline ? (
							<span className="error_msg_lbl text-red">Enter Tag </span>
						) : null} */}
				</div>

				<div className="form-group mt-3">
					<label htmlFor="About">About</label>
					<textarea
						type="text"
						className="form-control Dark-Input-from-group"
						placeholder="About"
						required
						onChange={(e) => handleFieldChange(setAbout, e.target.value)}
						value={about}
						invalid={displays && about === ""}
					></textarea>
					{/* {displays && !about ? (
						<span className="error_msg_lbl text-red">Write About</span>
					) : null} */}
				</div>

				<div className="form-group mt-3">
					<label htmlFor="Description">Description</label>
					<textarea
						type="text"
						className="form-control Dark-Input-from-group"
						placeholder="Description"
						required
						onChange={(e) => handleFieldChange(setDescription, e.target.value)}
						value={description}
						invalid={displays && description === ""}
					></textarea>
					{/* {displays && !description ? (
						<span className="error_msg_lbl text-red">Write Description </span>
					) : null} */}
				</div>


				<button
					//  className="btn btn-primary"
					onClick={InstituteUpdate}
					className="btn btn-primary"
				// onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
				// disabled={!formChanged || isSubmitting}
				// style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}

				>
					Update
				</button>
			</div>
		</>
	);
};

export default UpdateInstituteProfile;
